<template>
  <ChatGPT />
</template>

<script>
import ChatGPT from "./components/ChatQY.vue";
export default {
  name: "App",
  components: {
    ChatGPT,
  },
};

const handleResize = () => {
  location.reload();
};
// window.addEventListener("resize", handleResize);
</script>

<style>
</style>
